export class Grade {
  id: number = -1;
  name: string = '';
  ewcCodes: string = '';
  createdAt: string = '';
  updatedAt: string = '';
}
